import { Controller } from 'react-hook-form';
import { IconLoader, InputSize, InputText } from '@ui/src';
import InfoRow from '../../common/info-row';
import StepPartBlock from '../../common/step-part-block';
import { NewApplicationStatus } from '../../../../hoc/common/types';
import { ContactDetailsTypes } from './types';

import commonStyles from '../../common/styles.module.css';

const ContactDetails = ({
  questionnarieControl,
  questionnarieClearErrors,
  status,
  isEditable,
  questionnarieErrors,
  questionnarieIsLoading,
}: ContactDetailsTypes) => (
  <StepPartBlock title="Contact details">
    <>
      {questionnarieIsLoading && (
        <div className={commonStyles.dictionaryLoader}>
          <IconLoader />
        </div>
      )}
      {!questionnarieIsLoading && (
        <>
          <InfoRow
            title="Contact person name"
            id="contactPersonName"
            lessPadding
          >
            <Controller
              control={questionnarieControl}
              name="contactPersonName"
              defaultValue=""
              render={({ field: { onChange, value, name } }) => (
                <InputText
                  name={name}
                  placeholder="Enter name..."
                  value={value}
                  onChange={(e) => {
                    onChange(e);
                    questionnarieClearErrors(['contactPersonName']);
                  }}
                  size={InputSize.SMALL}
                  className="borderless"
                  disabled={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                  }
                  tabIndex={
                    !isEditable &&
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                      ? -1
                      : 0
                  }
                  error={questionnarieErrors?.contactPersonName?.message}
                />
              )}
            />
          </InfoRow>
          <InfoRow title="Phone number" id="phoneNumber" lessPadding>
            <Controller
              control={questionnarieControl}
              name="phoneNumber"
              defaultValue=""
              render={({ field: { onChange, value, name } }) => (
                <InputText
                  name={name}
                  placeholder="Enter number..."
                  value={value}
                  onChange={(e) => {
                    onChange(e);
                    questionnarieClearErrors(['phoneNumber']);
                  }}
                  size={InputSize.SMALL}
                  className="borderless"
                  disabled={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                  }
                  tabIndex={
                    !isEditable &&
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                      ? -1
                      : 0
                  }
                  error={questionnarieErrors?.phoneNumber?.message}
                />
              )}
            />
          </InfoRow>
          <InfoRow title="Fax number (optional)" id="faxNumber" lessPadding>
            <Controller
              control={questionnarieControl}
              name="faxNumber"
              defaultValue=""
              render={({ field: { onChange, value, name } }) => (
                <InputText
                  name={name}
                  placeholder="Enter number..."
                  value={value}
                  onChange={(e) => {
                    onChange(e);
                    questionnarieClearErrors(['faxNumber']);
                  }}
                  size={InputSize.SMALL}
                  className="borderless"
                  disabled={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                  }
                  tabIndex={
                    !isEditable &&
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                      ? -1
                      : 0
                  }
                  error={questionnarieErrors?.faxNumber?.message}
                />
              )}
            />
          </InfoRow>
          <InfoRow title="Contact email" id="contactEmail" lessPadding>
            <Controller
              control={questionnarieControl}
              name="contactEmail"
              defaultValue=""
              render={({ field: { onChange, value, name } }) => (
                <InputText
                  name={name}
                  placeholder="Enter email..."
                  value={value}
                  onChange={(e) => {
                    onChange(e);
                    questionnarieClearErrors(['contactEmail']);
                  }}
                  size={InputSize.SMALL}
                  className="borderless"
                  disabled={
                    !isEditable ||
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                  }
                  tabIndex={
                    !isEditable &&
                    Boolean(
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED,
                    )
                      ? -1
                      : 0
                  }
                  error={questionnarieErrors?.contactEmail?.message}
                />
              )}
            />
          </InfoRow>
        </>
      )}
    </>
  </StepPartBlock>
);

export default ContactDetails;
